import React from "react";
import DashboardTabs, {
  DashboardTabItem,
} from "../../../../common/dashboard/DashboardTabs";
import { TabId } from "./types";

export const tabItems: DashboardTabItem<TabId>[] = [
  { id: "globalSettings", label: "Global Settings" },
  { id: "membershipSettings", label: "Membership Settings" },
  { id: "emailCommunications", label: "Emails & Communication" },
  { id: "affinityProgramSetup", label: "Affinity Program Set Up" },
];

const SettingsTabs = ({
  activeTab,
  onTabChange,
}: {
  activeTab: TabId;
  onTabChange: (tabId: TabId) => void;
}) => (
  <DashboardTabs
    activeTab={activeTab}
    ariaLabel="Chamber settings tabs"
    items={tabItems}
    onTabChange={onTabChange}
  />
);

export default SettingsTabs;
